import React from 'react';

// Lazy load components - No lazy imports needed for these as they were already imported in App
const SignUp = React.lazy(() => import('../pages/ParentLogin/Login/SignUp'));
const ParentLogin = React.lazy(() => import('../pages/ParentLogin/Login/ParentLogin'));
const Statement = React.lazy(() => import('../pages/ParentLogin/Statement/Statement'));
const ParentPaymentDetails = React.lazy(() => import('../pages/ParentLogin/PaymentDetails'));
const ParentChargeDetails = React.lazy(() => import('../pages/ParentLogin/ChargeDetails'));
const AddParentPayment = React.lazy(() => import('../pages/ParentLogin/AddPayment'));
const SetupParentPayments = React.lazy(() => import('../pages/ParentLogin/SetupPayments'));
const ChangeParentPaymentMethod = React.lazy(() => import('../pages/ParentLogin/ChangePaymentMethod'));
const ParentLoginStudents = React.lazy(() => import('../pages/ParentLogin/Students/Students'));
const StudentDetails = React.lazy(() => import('../pages/ParentLogin/Students/StudentDetails'));
const Registration = React.lazy(() => import('../pages/ParentLogin/RegistrationNew/RegistrationNew'));
const News = React.lazy(() => import('../pages/ParentLogin/News'));

export const getParentLoginRoutes = () => [
  {
    path: '/parents/signup',
    element: <SignUp />
  },
  {
    path: '/parents/login',
    element: <ParentLogin />
  },
  {
    path: '/parents/statement',
    element: <Statement />,
    children: [
      {
        path: 'payment-details',
        element: <ParentPaymentDetails />
      },
      {
        path: 'charge-details',
        element: <ParentChargeDetails />
      },
      {
        path: 'new-payment',
        element: <AddParentPayment />
      },
      {
        path: 'setup-payments',
        element: <SetupParentPayments />
      },
      {
        path: 'change-payment-method',
        element: <ChangeParentPaymentMethod />
      }
    ]
  },
  {
    path: '/parents/students',
    element: <ParentLoginStudents />,
    children: [
      {
        path: 'student-details',
        element: <StudentDetails />
      }
    ]
  },
  {
    path: '/parents/registration',
    element: <Registration />
  },
  {
    path: '/parents/news',
    element: <News />
  }
];

